import {React, classNames} from '@api'
import * as css from './CentricLogo.css'
import { globalStores } from '@stores'
import CENTRIC_LOGO from './CentricLogo256.png'

export const CentricLogo : React.FC<{ className?: string}> = ({className}) => {
  return (<img data-type='CentricLogo' src={CENTRIC_LOGO} className={classNames(css.root, className)} />)
}


// WEBPACK FOOTER //
// ./src/stores/ui/CentricLogo.tsx